import _ from "lodash"
import dashboard from "../views/Dashboard";

export const getDashboardClientCode = dashboard => _.get(dashboard,['client_code'],"")
export const getDashboardClientName = dashboard => _.get(dashboard,['client_name'],"")
export const getDashboardClientBranchCode = dashboard => _.get(dashboard,['client', 'branch', 'code'],"")
export const getDashboardDataDate = dashboard => _.get(dashboard,['date_date','value'],"")
export const getDashboardFullCds = dashboard => _.get(dashboard,['client', 'full_cds_number'],"")

export const getDashboardRemisierCode = dashboard => _.get(dashboard,['remisier', 'code'],"")
export const getDashboardRemisierName = dashboard => _.get(dashboard,['remisier', 'name'],"")

export const getDashboardNetTrustAmount= dashboard => _.get(dashboard,['net_trust_amount'],0)
export const getDashboardNetLossAmount= dashboard => _.get(dashboard,['net_loss_amount'],0)
export const getDashboardNetBalanceAmount= dashboard => _.get(dashboard,['net_balance_amount'],0)
export const getDashboardTrustMoneyAmount= dashboard => _.get(dashboard,['trust_money_amount'],0)
export const getDashboardSalesProceedAmount = dashboard => _.get(dashboard,['sales_proceed_amount'],0)
export const getDashboardPurchasedContractAmount= dashboard => _.get(dashboard,['purchased_contract_amount'],0)
export const getDashboardContraGainAmount = dashboard => _.get(dashboard,['contra_gain_amount'],0)
export const getDashboardContraLossAmount = dashboard => _.get(dashboard,['contra_loss_amount'],0)
export const getDashboardInterestAmount = dashboard => _.get(dashboard,['interest_amount'],0)
export const getDashboardOtherBillsAmount = dashboard => _.get(dashboard,['other_bills_amount'],0)

export const getDashboardCurrencyCode = dashboard => _.get(dashboard,['currency_code'],"")
export const getDashboardCurrencyCodeSymbol = dashboard => _.get(dashboard,['currency_code', 'symbol'],"")
export const getDashboardTotalForceSaleAmount = dashboard => _.get(dashboard,['total_force_sale_amount'],'')

//margin summary
export const getMarginSummaryClientCode = marginSummary => _.get(marginSummary,['client_code'],'')
export const getMarginSummaryMarginCallDateText = marginSummary => _.get(marginSummary,['margin_call_date','text'],'')
export const getMarginSummaryMarginShortfallFullText = marginSummary => _.get(marginSummary,['margin_shortfall','full_text'],'')
